import React from 'react';
import InputWithIcon from '../generics/input-with-icon';
import { User, Mail } from 'lucide-react';
import { t } from 'i18next';

interface ClientInfoFormProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
}

const ClientInfoForm: React.FC<ClientInfoFormProps> = ({
  firstName,
  lastName,
  email,
  phone,
  onFirstNameChange,
  onLastNameChange,
  onEmailChange,
  onPhoneChange
}) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <InputWithIcon
          label={t('client.firstName', 'Prénom')}
          id="firstName"
          name="firstName"
          placeholder={t('client.firstName', 'Prénom') || ''}
          value={firstName}
          onChange={(e) => onFirstNameChange(e.target.value)}
          icon={<User size={16} />}
          required
        />
        <InputWithIcon
          label={t('client.lastName', 'Nom')}
          id="lastName"
          name="lastName"
          placeholder={t('client.lastName', 'Nom') || ''}
          value={lastName}
          onChange={(e) => onLastNameChange(e.target.value)}
          icon={<User size={16} />}
          required
        />
      </div>
      
      <div className="grid grid-cols-2 gap-2">
        <InputWithIcon
          label={t('client.email', 'Email')}
          id="email"
          name="email"
          type="email"
          placeholder={t('client.email', 'Email') || ''}
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          icon={<Mail size={16} />}
          required
        />
        <InputWithIcon
          label={t('client.phone', 'Téléphone')}
          id="phone"
          name="phone"
          type="tel"
          placeholder={t('client.phone', 'Téléphone') || ''}
          value={phone || ''}
          onChange={(e) => onPhoneChange(e.target.value)}
          icon={<Mail size={16} />}
        />
      </div>
    </>
  );
};

export default ClientInfoForm;
